import React from 'react';

const Why = () => (
  <section className="block block-why">
    <div className="row columns">
      <div className="block-header">
        <h2>Why choose crowdspring?</h2>
      </div>
    </div>
    <div className="row align-spaced">
      <div className="small-16 large-6 columns">
        <div className="content-block many">
          <h3>Talented creatives, lots of choice.</h3>
          <p>
            Stop wasting your valuable time elsewhere. Over&nbsp;200,000 talented creatives from 195 countries work on crowdspring.
            The&nbsp;average project receives 100 entries.
          </p>
        </div>
      </div>
      <div className="small-16 large-6 columns">
        <div className="content-block amazing">
          <h3>Award-winning customer support.</h3>
          <p>
            All the suport you need, when you need&nbsp;it. Our&nbsp;dedicated support team (99% customer satisfaction) is available by phone, email, and chat to ensure&nbsp;your&nbsp;success.
          </p>
        </div>
      </div>
      <div className="small-16 large-6 columns">
        <div className="content-block guarantee">
          <h3>Work you&#39;ll love, guaranteed.</h3>
          <p>
            Beautiful design that drives results. If&nbsp;you&#39;re not 100% happy with your design project, or if your naming project doesn&#39;t
            receive at least 100 entries, we&#39;ll&nbsp;promptly refund&nbsp;all&nbsp;of&nbsp;your&nbsp;money.
          </p>
        </div>
      </div>
      <div className="small-16 large-6 columns">
        <div className="content-block property">
          <h3>Protect your intellectual property.</h3>
          <p>
            Powerful intellectual property protections, made simple. Every&nbsp;project includes industry&#8209;leading, customized, dynamic legal contracts and policies that&nbsp;protect your intellectual&nbsp;property.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Why;



// WEBPACK FOOTER //
// ./marketing/common/whyCS.jsx